import React from 'react';
import Image from 'next/image';

import { Section, SectionTitle } from 'react-scale/components';

const ImageBlock = () => (
  <Section id="how-it-works">
    <SectionTitle
      overtitle="How It Works"
      title="Operationalize Machine Learning"
      subtitle="Scale Document AI has built base models relying on Scale’s expertise Computer Vision and Natural Language Processing. Document AI fine-tunes these Machine Learning models for your use case by annotating sample documents. The resulting models are ready to process your documents with human-level accuracy, in seconds. No templates needed."
    />
    <div className="bg-gray-800 border border-tundora sm:border-0 sm:bg-gray-900 rounded-2xl">
      <div className="pt-14 px-14 sm:pt-10 pb-6 sm:pb-[60px] sm:px-12">
        <div className="hidden mx-auto sm:flex max-w-max">
          <Image
            className="mx-auto"
            src="/static/images/pages/document/operationalized-ml-desktop.svg"
            alt="How It Works"
            loading="eager"
            priority
            width={865}
            height={400}
            layout="intrinsic"
          />
        </div>
        <div className="flex mx-auto sm:hidden max-w-max">
          <Image
            src="/static/images/pages/document/operationalized-ml-mobile.svg"
            alt="How It Works"
            loading="eager"
            priority
            width={214}
            height={1882}
            layout="intrinsic"
          />
        </div>
      </div>
      <hr className="border-0 h-[1px] bg-tundora sm:bg-gray-800 w-full" />
      <p className="pt-12 pb-14 px-[70px] sm:px-10 md:text-xs lg:text-base md:px-20 xl:px-52 md:pt-10 md:pb-10 text-gray-400 leading-6 lg:leading-6 text-center">
        Optional <br className="sm:hidden block" />
        human-in-the-loop QA is available for complex use cases, <br className="hidden sm:block" />
        and is also used to improve model performance.
      </p>
    </div>
  </Section>
);

export default ImageBlock;
